module.exports = __webpack_public_path__ + "static/img/banner.f96c3f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cereshop/home/banner.png
// module id = biE/
// module chunks = 14